import React from "react";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import TrendingUp from "@mui/icons-material/TrendingUp";
import EventOutlined from "@mui/icons-material/EventOutlined";
import SalesDashboard from "./SalesDashboard";
import CustomerDashboard from "./CustomerDashboard";
import SalesRepDashboard from "./SalesRepDashboard";
import MeetingDashboard from "./MeetingDashboard";
import { CrmTabbedPage } from "../shared/CrmUi";

// CRM dashboard sekmeleri; sayfa kabuğu TMS Control Tower ile aynı
const DashboardTabs = () => (
    <CrmTabbedPage
        title="Sales Dashboard"
        subtitle="Opportunity, customer, sales representative and meeting performance in one view."
        tabs={[
            { label: "Product", icon: Inventory2Outlined, component: <SalesDashboard /> },
            { label: "Customer", icon: GroupsOutlined, component: <CustomerDashboard /> },
            { label: "Sales", icon: TrendingUp, component: <SalesRepDashboard /> },
            { label: "Meeting", icon: EventOutlined, component: <MeetingDashboard /> },
        ]}
    />
);

export default DashboardTabs;
